import {
    DependenciesPayload,
    BillingProfile,
} from '@sxm-de/dev-kits/web-sdk/types';
import { MapClientSdkToWebSdk } from '@sxm-de/dev-kits/web-sdk/utils';

export async function getDefaultBillingProfile({
    clientSdk,
    appEventSdk,
}: DependenciesPayload): Promise<BillingProfile> {
    try {
        const mapClientSdkToWebSdk: MapClientSdkToWebSdk<
            Awaited<
                ReturnType<
                    typeof clientSdk.commerce.billing.getDefaultBillingProfile
                >
            >,
            BillingProfile
        > = (profile) => {
            return {
                ...profile,
                defaultPaymentMethodId: profile.defaultPaymentMethodId || '',
                serviceAddress: {
                    addressLine1: profile.serviceAddress?.addressLine1 || '',
                    city: profile.serviceAddress?.city || '',
                    state: profile.serviceAddress?.state || '',
                    zipCode: profile.serviceAddress?.zipCode || '',
                    country: profile.serviceAddress?.country,
                },
                status:
                    'open' in profile.status
                        ? {
                              open: {
                                  activeDisputes:
                                      profile.status.open.activeDisputes,
                                  serviceAddressStatus:
                                      profile.status.open.serviceAddressStatus,
                                  subscriptions:
                                      profile.status.open.subscriptions,
                              },
                          }
                        : { open: null },
            };
        };
        const profile = mapClientSdkToWebSdk(
            await clientSdk.commerce.billing.getDefaultBillingProfile(),
        );
        appEventSdk.trackEvent({
            event: 'customer-info',
            customerInfo: {
                firstName:
                    profile?.billingProfileName?.firstAndLastName?.firstName,
                lastName:
                    profile?.billingProfileName?.firstAndLastName?.lastName,
                //add phone once is available from MS
                //phone: null
                serviceAddress: {
                    state: profile?.serviceAddress?.state,
                },
            },
        });

        return profile;
    } catch (error: any) {
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        throw new Error('SYSTEM');
    }
}
